import portCallStatuses from 'constants/portCallStatuses'
import PropTypes from 'prop-types'

export default PropTypes.oneOf([
  portCallStatuses.CLOSED,
  portCallStatuses.INTERRUPTED,
  portCallStatuses.OPEN,
])
